<template>
  <div class="flex fixed inset-0 bg-black/75 z-50">
    <div class="w-full max-w-xs overflow-hidden rounded-2xl m-auto relative">
      <div class="bg-[#fcf1de] pt-10">
        <i class="w-28 block mx-auto -mb-14" v-icon:employed></i>
      </div>
      <div class="bg-white pt-20 px-4 pb-8 flex flex-col gap-10">
        <div class="flex flex-col gap-4">
          <h2 class="text-2xl text-yellow-dark-80">GPS</h2>
          <p>
            Sin acceso a la ubicación actual
          </p>
        </div>
        <button @click="onClose" class="text-white transition bg-primary-0 hover:bg-primary-dark-40 py-3 px-6 text-center rounded-2xl w-full">
          Cerrar
        </button>
      </div>
      <button @click="onClose" title="Close modal" class="absolute top-5 right-5 w-6 p-[3px] rounded-full bg-neutral-80 text-white">
        <i v-icon:close-alt></i>
      </button>
    </div>
  </div>
</template>

<script>

  export default {
    name: "VMapModal",
    data(){
      return {

      }
    },
    methods: {
      onClose(){
        this.$emit('close');
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>